export function useSmartCaptcha(form: HTMLFormElement | null) {
    let captchaId = ref<number | undefined>(undefined);
    let captchaToken = ref<string | undefined>(undefined);
    const isInited = ref(false);
    const captchaKey = useRuntimeConfig().public.smartCaptchaKey;
    
    const initSmartCaptcha = async () => {
        if (captchaKey) {
            if (window['smartCaptcha']) {
                let captchaContainer = form?.value.querySelector('.captcha-container');
                if (!captchaContainer) {
                    captchaContainer = document.createElement('div');
                    captchaContainer.className = 'captcha-container';
                    form?.value.appendChild(captchaContainer);
                }

                captchaId.value = window['smartCaptcha'].render(captchaContainer, {
                    sitekey: captchaKey,
                    invisible: true,
                    hideShield: true,
                    callback: (genToken) => captchaToken.value = genToken,
                    hl: 'ru'
                });
                
                isInited.value = true;
                return;
            }
        }
        isInited.value = true;
        captchaId.value = undefined
    }

    const testCaptcha = async () => {
        if(!isInited.value) {
            while(!isInited.value) await new Promise(resolve => setTimeout(resolve, 100));
        }
        return new Promise<boolean>(async (resolve, reject) => {
            if (!captchaKey || !window['smartCaptcha']) {
                resolve(true);
                return;
            }

            if (captchaId.value === undefined) {
                reject('SmartCaptcha initialization failed');
                return;
            }

            if (window['smartCaptcha'].getResponse(captchaId.value)) {
                resolve(true)
            }

            window['smartCaptcha'].subscribe(captchaId.value, 'success', () => resolve(true))
            window['smartCaptcha'].subscribe(captchaId.value, 'network-error', () => reject('SmartCaptcha network-error'))
            window['smartCaptcha'].subscribe(captchaId.value, 'token-expired', () => reject('SmartCaptcha token-expired'))

            const timeout = setTimeout(() => reject('SmartCaptcha execution failed'), 30000) // 30 seconds

            window['smartCaptcha'].subscribe(captchaId.value, 'challenge-visible', () => clearTimeout(timeout))
            window['smartCaptcha'].execute(captchaId.value);
        })
    }

    const updateCaptcha = async() => {
        if (isInited?.value && captchaKey && window['smartCaptcha']) {
            isInited.value = false;
            await window['smartCaptcha'].destroy(captchaId.value);
            initSmartCaptcha();
        }
    }

    const captchaForm = form as {value?: HTMLFormElement | null} | null | undefined

    const tryInit = () => {
        if (isInited.value || !captchaForm?.value) {
            return
        }

        void initSmartCaptcha()
    }

    onMounted(() => {
        setTimeout(tryInit, 0)
    })

    watch(() => captchaForm?.value, () => {
        tryInit()
    })

    return {testCaptcha, form, captchaId, captchaToken, updateCaptcha}
}
